import { render, staticRenderFns } from "./BaseBadge.vue?vue&type=template&id=bf90e61a&scoped=true&"
import script from "./BaseBadge.vue?vue&type=script&lang=js&"
export * from "./BaseBadge.vue?vue&type=script&lang=js&"
import style0 from "./BaseBadge.vue?vue&type=style&index=0&id=bf90e61a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf90e61a",
  null
  
)

export default component.exports